import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// Track loading state
let translationsReady = false;
const readyCallbacks = [];
// Return possible variants for a language code to maximize chances of fetching
// Example: "fr-ca" => ["fr-ca", "fr-CA", "fr"]
const getLanguageFetchCandidates = (languageCode) => {
    const lower = (languageCode || "").toLowerCase();
    const candidates = [];
    if (!lower)
        return candidates;
    candidates.push(lower);
    if (lower.includes("-")) {
        const [lang, region] = lower.split("-");
        if (lang && region) {
            candidates.push(`${lang}-${region.toUpperCase()}`);
            candidates.push(lang);
        }
    }
    // De-duplicate while preserving order
    return Array.from(new Set(candidates));
};
// Public config that consumers can override from other projects
export const yardiTranslationConfig = {
    // Base API path used to fetch translation resources
    languageApiBase: "",
    parameters: {}
};
// Function to load language files from API (proxy expected in dev)
const loadLanguageFromAPI = async (languageCode) => {
    //const candidates = getLanguageFetchCandidates(languageCode);
    const queryString = new URLSearchParams(yardiTranslationConfig.parameters).toString();
    //const md5response = await fetch('/api/reactlocalization/consolidated/translations/v3/md5/locale-'+languageCode+'?productName=onlineleasingstudent&propertyid=229591', {
    const contentURL = yardiTranslationConfig.languageApiBase + '/api/reactlocalization/consolidated/translations/v3/md5/locale-' + languageCode + '?' + queryString;
    //const md5response = await fetch(yardiTranslationConfig.languageApiBase + '/api/reactlocalization/consolidated/translations/v3/md5/locale-'+languageCode+'?'+queryString, {
    const md5response = await fetch(contentURL, {
        method: "GET",
        credentials: "include"
    });
    if (md5response.ok) {
        const md5data = await md5response.json();
        //for (const candidate of candidates) {
        try {
            /*const response = await fetch(`${yardiTranslationConfig.languageApiBase}/${candidate}`, {
              method: "GET",
              credentials: "include"
            });*/
            //const response = await fetch('/api/reactlocalization/consolidated/translations/v3/locale-'+languageCode+'?md5hash='+ md5data.md5 +'&productName=onlineleasingstudent&propertyid=229591', {
            //const response = await fetch(yardiTranslationConfig.languageApiBase + '/api/reactlocalization/consolidated/translations/v3/locale-'+languageCode+'?md5hash='+ md5data.md5 +'&'+queryString, {
            const contentURL2 = yardiTranslationConfig.languageApiBase + '/content3/reactlocalization/consolidated/translations/v3/locale-' + languageCode + '.json?v=' + md5data.md5 + '&' + queryString;
            const response = await fetch(contentURL2, {
                method: "GET",
                credentials: "include"
            });
            if (!response.ok) {
                console.warn(`Failed to load ${languageCode}: ${response.status}`);
                //continue;
            }
            const data = await response.json();
            const keysLen = data && typeof data === "object" ? Object.keys(data).length : 0;
            console.log(`✅ Loaded ${languageCode} from API${keysLen ? `, keys: ${keysLen}` : ""}`);
            return data;
        }
        catch (error) {
            console.error(`Error loading ${languageCode}:`, error);
            // Try next candidate
        }
    }
    //}
    //console.warn(`No translation data could be fetched for ${languageCode} (candidates tried: ${candidates.join(", ")})`);
    return null;
};
const LANG_KEY = "user-preferred-language";
// Initialize i18next with empty resources first
i18n.use(initReactI18next).init({
    lng: "en",
    fallbackLng: "en",
    resources: {},
    ns: ["translation"],
    defaultNS: "translation",
    lowerCaseLng: true,
    interpolation: {
        escapeValue: false
    },
    react: {
        useSuspense: false // Prevent suspense loading
    }
});
const yardireacttranslationService = {
    async setLanguage(langCode, serverUpdate = false) {
        console.log("Setting language to:", langCode);
        langCode = langCode.toLowerCase();
        // Validate language code - if invalid, don't set it
        if (!langCode) {
            console.warn("Invalid language code:", langCode);
            // Remove invalid language from localStorage
            localStorage.removeItem(LANG_KEY);
            langCode = "en"; // Default to English
        }
        // Ensure language is loaded
        await this.ensureLanguageLoaded(langCode);
        await i18n.changeLanguage(langCode);
        localStorage.setItem(LANG_KEY, langCode);
    },
    async ensureLanguageLoaded(langCode) {
        await i18n.removeResourceBundle(langCode, "translation");
        if (!i18n.hasResourceBundle(langCode, "translation")) {
            console.log(`Loading translation bundle for ${langCode}...`);
            const data = await loadLanguageFromAPI(langCode);
            if (data && typeof data === "object") {
                i18n.addResourceBundle(langCode, "translation", data, true, true);
                console.log(`Added translation bundle for ${langCode}`);
            }
            else {
                console.warn(`No translation data available for ${langCode}`);
            }
        }
    },
    // Method to wait for translations to be ready
    async waitForReady() {
        return new Promise((resolve) => {
            if (translationsReady) {
                resolve();
            }
            else {
                readyCallbacks.push(resolve);
            }
        });
    },
    i18n
};
// LOAD ENGLISH IMMEDIATELY ON STARTUP
export async function initTranslations() {
    console.log("🔄 Loading English translations on startup...");
    const englishData = await loadLanguageFromAPI("en");
    if (englishData) {
        i18n.addResourceBundle("en", "translation", englishData, true, true);
        console.log("✅ English translations loaded from API");
    }
    // Check if user has a stored language preference
    const storedLanguage = localStorage.getItem(LANG_KEY);
    if (storedLanguage && storedLanguage !== "en") {
        console.log(`🔄 Found stored language: ${storedLanguage}, loading it...`);
        try {
            // Load the stored language
            await yardireacttranslationService.ensureLanguageLoaded(storedLanguage);
            // Set it as the current language
            await i18n.changeLanguage(storedLanguage);
            console.log(`✅ App initialized with stored language: ${storedLanguage}`);
        }
        catch (error) {
            console.error(`❌ Failed to load stored language ${storedLanguage}:`, error);
            // Fall back to English if stored language fails to load
            await i18n.changeLanguage("en");
        }
    }
    else {
        // No stored language or it's English, use English
        await i18n.changeLanguage("en");
        console.log("✅ App initialized with default language: English");
    }
    // Mark translations as ready
    translationsReady = true;
    readyCallbacks.forEach((callback) => callback());
    readyCallbacks.length = 0;
}
export default yardireacttranslationService;
